import { FlagSnapshotPayloadData } from '@modules/HappinessModule/interfaces/FlagSnapshotPayloadData';
import { createAction } from '@reduxjs/toolkit';

export const getFlagDataAction = createAction<string>('flagPage/getFlagDataAction');
export const getFlagSnapshotAction = createAction<FlagSnapshotPayloadData>('flagPage/getFlagSnapshotAction');
export const getUserPermissionToModifyFlagAction = createAction<string>('flagPage/getUserPermissionToModifyFlagAction');
export const reopenFlagAction = createAction<string>('flagFormPage/reopenFlagAction');
